import React from "react";
import { Global, css } from "@emotion/core";
import { theme } from "../theme";

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        :root {
          height: 100%;
          font-size: 12px;
          overflow-x: hidden;

          @media (min-width: ${theme.breakpoints[0]}) {
            font-size: 14px;
          }

          @media (min-width: ${theme.breakpoints[1]}) {
            font-size: 16px;
          }
        }

        body {
          height: 100vh;
          font-family: ${theme.fonts.body};
          letter-spacing: 0.1px;
          -webkit-font-smoothing: antialiased;
        }

        .ReactVirtualized__Grid__innerScrollContainer,
        .ReactVirtualized__Table__row {
          overflow: visible !important;
        }

        .ReactVirtualized__Table__rowColumn.visble-overflow {
          overflow: visible !important;
        }
      `}
    />
  );
};

export default GlobalStyles;
